<template>
  <div class="register-consent-checkboxes flex flex-col gap-2">
    <nd-checkbox v-model:checked="isTermsAccepted" v-bind="termsAcceptedProps">
      <p class="text-black-50 text-sm">
        <trans i18n-key="log_in_create_account_term_of_use" :components="transComponents" />
      </p>
    </nd-checkbox>

    <nd-checkbox v-model:checked="isMarketingAllowed" v-bind="marketingAllowedProps">
      <p class="text-black-50 text-sm">
        {{ $t('log_in_create_account_marketing_agreement') }}
      </p>
    </nd-checkbox>
  </div>
</template>

<script setup lang="ts">
import LocaleLink from '@/components/global/locale-link.vue'
import NdCheckbox from '@/components/form/nd-checkbox.vue'

const isTermsAccepted = defineModel<boolean>('isTermsAccepted', { default: true })
const isMarketingAllowed = defineModel<boolean>('isMarketingAllowed', { default: true })

const transComponents = computed(() => ({
  terms: { tag: LocaleLink, props: { class: 'text-yellow-50', to: { path: '/policy' }, target: '_blank' } },
  policy: { tag: LocaleLink, props: { class: 'text-yellow-50', to: { path: '/privacy' }, target: '_blank' } },
}))

defineProps<{
  termsAcceptedProps?: Record<string, any>
  marketingAllowedProps?: Record<string, any>
}>()
</script>
